module.exports = __webpack_public_path__ + "static/phreesia-fd8d64519d5f51a2f68674e7585cae9d.png";